import mimeTypesToFormat from "./mimeTypesToFormat";

// eslint-disable-next-line import/prefer-default-export
export const docToAttachedFile = (doc) => ({
  docId: doc.id,
  url: doc.url,
  name: doc.name,
  format: mimeTypesToFormat(doc.mimetype),
});
